import { useEffect, useState } from "react";
import { useTranslate } from "@tolgee/react";

import { LandingPrimaryCta } from "./landing-primary-cta.tsx";

import { NAV_LINKS } from "#/components/header/nav-links";
import { TenbaggerLogo } from "#/components/ui/logo.tsx";
import {LanguageSwitcher} from "#/components/locale/language-switcher.tsx";
import { LocalizedLink } from "#/components/locale/localized-link";

export function LandingNav() {
	const { t } = useTranslate();
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 32);
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	return (
		<header
			className="sticky top-0 z-10 w-full border-b transition-all duration-500"
			style={{
				borderColor: scrolled
					? "color-mix(in oklab, var(--trade-border-subtle) 60%, transparent)"
					: "color-mix(in oklab, var(--trade-border-subtle) 30%, transparent)",
				backgroundColor: scrolled
					? "color-mix(in oklab, var(--color-primitives-coolneutral-7) 92%, transparent)"
					: "color-mix(in oklab, var(--color-primitives-coolneutral-7) 72%, transparent)",
				backdropFilter: scrolled ? "blur(24px)" : "blur(8px)",
				boxShadow: scrolled ? "0 8px 32px rgb(0 0 0 / 0.3)" : "none",
			}}
		>
			<div className="mx-auto flex w-[calc(100%-16px)] max-w-345 flex-wrap items-center justify-between gap-6 px-[16px] pt-[30px] pb-[9px] md:w-[calc(100%-24px)] lg:w-[calc(100%-48px)]">
				<div className="flex items-center gap-2">
					<TenbaggerLogo />
					<span className="hidden text-title1 text-foreground md:inline">
						Tenbagger
					</span>
				</div>

				<nav
					className="order-3 flex w-full items-center justify-center gap-6 text-body2 text-foreground lg:order-none lg:w-auto lg:gap-15"
					aria-label={t("nav.aria-label")}
				>
					{NAV_LINKS.map((link) => (
						<LocalizedLink
							key={link.to}
							to={link.to}
							className="relative whitespace-nowrap transition-colors duration-200 hover:text-foreground"
							activeProps={{ className: "relative text-foreground" }}
						>
							{t(link.labelKey)}
						</LocalizedLink>
					))}
				</nav>

				<div className={'flex items-center gap-x-3'}>
					<LandingPrimaryCta label={t("nav.launch-app")} location="nav" className="py-2" />

					<LanguageSwitcher />
				</div>
			</div>
		</header>
	);
}
